import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\details\\Details.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\media\\NewsDetails.jsx");
